module.exports = {"610621001":"七里村街道","610621101":"黑家堡镇","610621102":"郑庄镇","610621103":"张家滩镇","610621104":"交口镇","610621106":"雷赤镇","610621107":"罗子山镇","610621108":"安沟镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610621.json
// module id = 2835
// module chunks = 0